module.exports = __webpack_public_path__ + "img/save.e27ab5a5.svg";